import { useState } from "react";
import { useReactiveVar } from "@apollo/client/react/hooks/useReactiveVar";
import { Box, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { ButtonCustom, ModalInput } from "../../../../shared/Style/Style";
import {
  CurrentBundleContainer,
  MobileAppModalBundleName,
} from "../../../MobileAppModal.style";
import ExperimentModelsListModal from "./ExperimentModelsListModal";
import { mobileAppModel } from "../../state";

const AttachExperimentModelButton = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const [isOpenModelsList, setIsOpenModelsList] = useState(false);

  return (
    <Box mb={4}>
      <CurrentBundleContainer>
        {model?.modelBundle?.name ? (
          <ModalInput
            disabled
            value={model?.modelBundle?.name}
            label="Експеримент (Bundle і Manifest)"
            multiline
            style={{ width: "460px" }}
          />
        ) : (
          <MobileAppModalBundleName>
            Експеримент (Bundle і Manifest)
          </MobileAppModalBundleName>
        )}

        {model?.modelBundle?.id ? (
          <IconButton onClick={() => mobileAppModel.deleteExperimentModel()}>
            <Delete color="secondary" />
          </IconButton>
        ) : (
          <ButtonCustom
            disabled={!model?.contentType?.name}
            onClick={() => setIsOpenModelsList(true)}
          >
            Прикріпити
          </ButtonCustom>
        )}
      </CurrentBundleContainer>
      {isOpenModelsList && (
        <ExperimentModelsListModal onClose={() => setIsOpenModelsList(false)} />
      )}
    </Box>
  );
};

export default AttachExperimentModelButton;
